
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexkIEbRaXbSPuW0J4wRlqApYEFdbEy0aMfHr8BvuPzTZMMeta } from "/app/pages/[slug]/index.vue?macro=true";
import { default as login4Mr5HfTEfOXidvTclwQjDJgZRsYDgmjOaJcTRdIJhjUMeta } from "/app/pages/[slug]/login.vue?macro=true";
import { default as entrance_45ZJSHIFP9UuhyrmnIzaGhhqB79i6a4CmqQC_45cuF6ar0Meta } from "/app/pages/[slug]/entrance.vue?macro=true";
import { default as settingsFewD55G4MFsZ4KxBqsTzvyrcyJu9TnAo1EYTy9enXVoMeta } from "/app/pages/[slug]/settings.vue?macro=true";
import { default as dashboardwL8lSzqV42otDzrz540_45mBwwLXldIks_45f3TvUlUa4MEMeta } from "/app/pages/[slug]/dashboard.vue?macro=true";
import { default as inventorybw8eaKLLF1XelWRweLmm2ozIHxFKOPLbyhcCfVvFCcEMeta } from "/app/pages/[slug]/inventory.vue?macro=true";
import { default as production_45exportHPgE1pDBZ7gUfeAc_37qMxi6_45YCxe8RKjBWIhoPXPmoMeta } from "/app/pages/[slug]/production-export.vue?macro=true";
import { default as _91id_93LboEj1KLbdhC4FCM5rfXKPI23lDHE_45mDk6KN7vf95lEMeta } from "/app/pages/[slug]/remote-storages/[id].vue?macro=true";
import { default as indexHHAxW6lDHC8fAFeVle2QaM4Y4smHlHPeGIv1VCmYTagMeta } from "/app/pages/[slug]/remote-storages/index.vue?macro=true";
import { default as _91token_932fpvyZghOyq3XKn922Nv2OVg231_4cfX8dae9VjqnvAMeta } from "/app/pages/[slug]/reset-password/[token].vue?macro=true";
import { default as _91id_93P15ZvEzThj8EmBV8MMOIbsuuOvm_45uUARt3Ci7mUSyDUMeta } from "/app/pages/[slug]/production-methods/[id].vue?macro=true";
import { default as indexlg1anpMqz_450L4KehQptAaa2g6_453eChXpf_452JpXKivJcMeta } from "/app/pages/[slug]/production-methods/index.vue?macro=true";
import { default as index01liTSJSnSPhy0Ip8LaO_45upQf0n_45_45HEZsV_FR9RklOYMeta } from "/app/pages/[slug]/presorting/[productionMethodId]/index.vue?macro=true";
import { default as _91id_93RkwizzGEOtev_45nG_45_xVY_KWbv_45WPiiIL53xdYysBqXoMeta } from "/app/pages/[slug]/presorting/[productionMethodId]/racks/[id].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug()",
    component: () => import("/app/pages/[slug]/index.vue")
  },
  {
    name: "slug-login",
    path: "/:slug()/login",
    meta: login4Mr5HfTEfOXidvTclwQjDJgZRsYDgmjOaJcTRdIJhjUMeta || {},
    component: () => import("/app/pages/[slug]/login.vue")
  },
  {
    name: "slug-entrance",
    path: "/:slug()/entrance",
    meta: entrance_45ZJSHIFP9UuhyrmnIzaGhhqB79i6a4CmqQC_45cuF6ar0Meta || {},
    component: () => import("/app/pages/[slug]/entrance.vue")
  },
  {
    name: "slug-settings",
    path: "/:slug()/settings",
    meta: settingsFewD55G4MFsZ4KxBqsTzvyrcyJu9TnAo1EYTy9enXVoMeta || {},
    component: () => import("/app/pages/[slug]/settings.vue")
  },
  {
    name: "slug-dashboard",
    path: "/:slug()/dashboard",
    component: () => import("/app/pages/[slug]/dashboard.vue")
  },
  {
    name: "slug-inventory",
    path: "/:slug()/inventory",
    meta: inventorybw8eaKLLF1XelWRweLmm2ozIHxFKOPLbyhcCfVvFCcEMeta || {},
    component: () => import("/app/pages/[slug]/inventory.vue")
  },
  {
    name: "slug-production-export",
    path: "/:slug()/production-export",
    meta: production_45exportHPgE1pDBZ7gUfeAc_37qMxi6_45YCxe8RKjBWIhoPXPmoMeta || {},
    component: () => import("/app/pages/[slug]/production-export.vue")
  },
  {
    name: "slug-remote-storages-id",
    path: "/:slug()/remote-storages/:id()",
    meta: _91id_93LboEj1KLbdhC4FCM5rfXKPI23lDHE_45mDk6KN7vf95lEMeta || {},
    component: () => import("/app/pages/[slug]/remote-storages/[id].vue")
  },
  {
    name: "slug-remote-storages",
    path: "/:slug()/remote-storages",
    meta: indexHHAxW6lDHC8fAFeVle2QaM4Y4smHlHPeGIv1VCmYTagMeta || {},
    component: () => import("/app/pages/[slug]/remote-storages/index.vue")
  },
  {
    name: "slug-reset-password-token",
    path: "/:slug()/reset-password/:token()",
    meta: _91token_932fpvyZghOyq3XKn922Nv2OVg231_4cfX8dae9VjqnvAMeta || {},
    component: () => import("/app/pages/[slug]/reset-password/[token].vue")
  },
  {
    name: "slug-production-methods-id",
    path: "/:slug()/production-methods/:id()",
    meta: _91id_93P15ZvEzThj8EmBV8MMOIbsuuOvm_45uUARt3Ci7mUSyDUMeta || {},
    component: () => import("/app/pages/[slug]/production-methods/[id].vue")
  },
  {
    name: "slug-production-methods",
    path: "/:slug()/production-methods",
    meta: indexlg1anpMqz_450L4KehQptAaa2g6_453eChXpf_452JpXKivJcMeta || {},
    component: () => import("/app/pages/[slug]/production-methods/index.vue")
  },
  {
    name: "slug-presorting-productionMethodId",
    path: "/:slug()/presorting/:productionMethodId()",
    meta: index01liTSJSnSPhy0Ip8LaO_45upQf0n_45_45HEZsV_FR9RklOYMeta || {},
    component: () => import("/app/pages/[slug]/presorting/[productionMethodId]/index.vue")
  },
  {
    name: "slug-presorting-productionMethodId-racks-id",
    path: "/:slug()/presorting/:productionMethodId()/racks/:id()",
    meta: _91id_93RkwizzGEOtev_45nG_45_xVY_KWbv_45WPiiIL53xdYysBqXoMeta || {},
    component: () => import("/app/pages/[slug]/presorting/[productionMethodId]/racks/[id].vue")
  }
]